
export default (account, discount, referral_discount = null) => {
  if (referral_discount !== null && referral_discount !== undefined && referral_discount !== '') {
    return Number(discount[referral_discount]) || 0
  }

  if (!discount) return 0
  if (typeof discount === 'number') return discount
  if (typeof discount === 'string') return Number(discount) || 0

  if (!account) {
    return Number(discount['retail'] || 0)
  }

  return Number(discount[account?.type] || discount['retail'] || 0)
}